import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleVerticalMoveBehavior extends ObstacleBehavior {
  private time: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleVertical', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed;
    const offset = Math.sin(this.time) * this.config.height;
    this.mesh.position.y = this.startPosition.y + offset;
  }
  clone(): ObstacleVerticalMoveBehavior {
    return new ObstacleVerticalMoveBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
